import React from "react";
import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuildingYourVision() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="34613" id="ubuds-premier-event-destination" className="dark bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-0">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-5">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="inline-flex items-center gap-2 text-secondary font-medium tracking-wide uppercase text-sm">
              <MapPin className="w-4 h-4" />
              <span>Nestled in the Heart of Peliatan, Ubud</span>
            </div>

            <h1 className="font-sans text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.1]">
              Ubud’s Premier Venue for <br />
              <span className="text-primary">Private Gatherings</span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              Experience an intimate sanctuary in Peliatan, where organic bamboo architecture meets the timeless beauty of Ubud’s rice fields. Our flexible spaces are designed for those seeking a scenic, accessible, and truly premium destination for life's most celebrated moments.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-2">
              <Button asChild size="lg" className="text-base px-8 h-14 bg-primary text-primary-foreground hover:opacity-90 animate-pulse">
                <Link to="/ConnectPage">
                  Book via WhatsApp
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-base px-8 h-14 border-primary/20 hover:bg-primary/10 hover:text-primary hover:border-primary">
                <Link to="/BambooHallPage">Explore Spaces</Link>
              </Button>
            </div>

            {}
            <div className="pt-8 border-t border-border/40 flex flex-wrap gap-8 text-sm text-muted-foreground font-medium">
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-secondary" />
                Rice Field Surroundings
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-secondary" />
                Ample Private Parking
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-secondary" />
                Central Peliatan Location
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative h-[500px] lg:h-[700px] w-full flex items-center justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute top-0 right-0 w-[85%] h-[85%] bg-muted rounded-xl overflow-hidden shadow-2xl border border-border/50 z-10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/mcoak_hero_exterior.png" alt="Organic bamboo architecture of the event hall in Ubud" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>

            {}
            <div className="absolute bottom-8 left-0 lg:-left-8 w-[55%] h-[45%] bg-background p-2 rounded-xl shadow-2xl z-20 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-500 fill-mode-forwards">
              <div className="w-full h-full relative overflow-hidden rounded-lg border border-border">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/mcoak_hero_interior.png" alt="Intimate private dining setup with rice field views" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              {}
              <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-primary/20 -z-10 rounded-br-2xl" />
            </div>

            {}
            <div className="absolute top-10 right-10 w-24 h-24 border-t-2 border-r-2 border-primary/30 rounded-tr-3xl -z-10" />
            <div className="absolute bottom-20 left-10 w-32 h-32 border-b-2 border-l-2 border-primary/30 rounded-bl-3xl -z-10" />
          </div>
        </div>
      </div>
    </section>;
}